export default __webpack_public_path__ + "static/media/inex.9b8af24d.svg";